// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"OTPModal_placeholder__gF57R","loader":"OTPModal_loader__0ulYZ"};